/**
 * Offer binding transitions for the step "Offer Configuration" panel.
 *
 * An offer page whose binding is emptied renders a dead page to the buyer
 * ("No offer available") after they have already paid, so the list must never
 * shrink below `min`. When it is already at `min` the X means "replace", and
 * the swap is committed as a single change once a replacement is picked.
 */

export function canRemoveOffer(values: string[], min: number): boolean {
  return values.length > min;
}

export function removeOffer(values: string[], offerId: string): string[] {
  const index = values.indexOf(offerId);
  if (index === -1) return values;
  return [...values.slice(0, index), ...values.slice(index + 1)];
}

export function replaceOffer(values: string[], replacedId: string, offerId: string): string[] {
  return values.map((id) => (id === replacedId ? offerId : id));
}
